import React from 'react';
import classnames from 'classnames';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

import { Button } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';
import { Menu } from 'uikit/menus';
import { Typo } from 'uikit/content';

import { getSelectedOptions, getSelectionAncestors } from '../helpers/selectionHelpers';

import FilterOptions from './filterOptions';

import styles from '../styles/filter.module.scss';

const Filter = ({
  dropdownPosition,
  isLoading,
  name,
  onDropdownToggle,
  onSelectionUpdate,
  options,
  param,
  selection,
  shouldAllItemsBeSelectable
}) => {
  const selectedOptions = getSelectedOptions(selection, options);
  const selectionAncestors = getSelectionAncestors(selectedOptions, options);
  const selectedOptionsCount = selectedOptions.length;
  const isActive = Boolean(selectedOptionsCount);

  const getTitleElement = (text, isBold) => (
    <Typo
      className={styles.name}
      element="span"
      modifier={isBold ? 'bold' : ''}
      variant="s01"
    >
      {text}
    </Typo>
  );

  const title = !isActive ? getTitleElement(name) : (
    <>
      {getTitleElement(selectedOptions[0].text, true)}
      {selectedOptionsCount > 1 && getTitleElement(` (+${selectedOptionsCount - 1})`)}
    </>
  );

  return (
    <div className={styles.container}>
      <Menu
        className={classnames(styles.element, styles.filter, {
          [styles.isActive]: isActive,
        })}
        component={(
          <Button
            icon={<KeyboardArrowDown />}
            iconPosition="right"
            iconSize={18}
            variant="outlined"
          >
            {title}
          </Button>
        )}
        horizontalPosition={dropdownPosition}
        onIsOpenChange={onDropdownToggle}
        overlay={isLoading && (
          <div className={styles.loaderContainer}>
            <Loading className={styles.loader} />
          </div>
        )}
        shouldCloseOnTab={false}
      >
        <FilterOptions
          isLoading={isLoading}
          onSelectionUpdate={onSelectionUpdate}
          options={options}
          param={param}
          selection={selection}
          selectionAncestors={selectionAncestors}
          shouldAllItemsBeSelectable={shouldAllItemsBeSelectable}
        />
      </Menu>
    </div>
  );
};

export default React.memo(Filter);
